import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

const ListaPrecioFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const [listasPrecio, setListasPrecio] = React.useState([])

  React.useEffect(() => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.LISTAPRECIO).then(({ data }) => {
      setListasPrecio(data)
    })
  }, [])

  return (
    <Form.Group>
      <Form.Label text='LISTA' htmlFor='select-idListaPrecio' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idListaPrecio'>
          {({ field }) => (
            <Form.Select {...field} id='select-idListaPrecio' isInvalid={iTouched && iError} disabled={fIsSubmitting}>
              <option value=''>Seleccionar</option>
              {listasPrecio.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ListaPrecioFormGroup)
